import { ALL_INDIVIDUAL_PLANS, PLAN_REF_ID_MAPPING } from "@/data/plans";
import { TProductRefId } from "@/types/plan";

/**
 * - Auto-select bundle if all individual plans are selected
 * - Default to bundle if no plans selected
 */
export function applyAutoBundleSelection(
  planIds: TProductRefId[],
): TProductRefId[] {
  // Auto-select bundle if all individual plans are selected
  const hasAllIndividualPlans = ALL_INDIVIDUAL_PLANS.every((planId) =>
    planIds.includes(planId),
  );

  if (hasAllIndividualPlans) {
    return [PLAN_REF_ID_MAPPING.all];
  }

  // Default to bundle if no plans selected
  if (planIds.length === 0) {
    return [PLAN_REF_ID_MAPPING.all];
  }

  return planIds;
}
